import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

import WasteTippingReceipts from './WasteTippingReceipts';
import WasteDetailsForm from './WasteDetails';
import WasteTippingJobs from './WasteTippingJobs';
import WasteTippingService from '../../services/WasteTippingService';

const WasteTippingForm = ({ wasteId }) => {
    const [waste, setWaste] = useState(null);
    const [jobs, setJobs] = useState([]);
    const [receiptList, setReceiptList] = useState([]);
    const [members, setMembers] = useState([]);
    const [tipOff, setTipOff] = useState(null);
    const [loading, setLoading] = useState(true);
    const approved = !!(tipOff && tipOff.reviewed_at);
    const service = new WasteTippingService();
    useEffect(() => {
        const fetchAll = async () => {
            try {
                const res = await axios.get(`/jobs/waste-tipping/${wasteId}/json`);
                setWaste(res.data.waste);
                setJobs(res.data.jobs || []);
                setReceiptList(res.data.receipts || []);
                setMembers(res.data.members || []);
                setTipOff(res.data.tip_off || null);
            } catch (err) {
                console.error('Failed to load waste tipping data:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchAll();
    }, [wasteId]);

    const handleApprove = async () => {
        if (!waste) return;

        try {
            const res = await service.approveWasteTipping(waste.id);
            if (res.data.success) {
                setTipOff((prev) => ({ ...prev, reviewed_at: res.data.reviewedAt }));
                alert('Tip-off approved!');
            } else {
                alert(res.data.message || 'Approval failed');
            }
        } catch (err) {
            console.error('Approval failed:', err);
            alert('Approval failed');
        }
    };

    const renderSignOff = () => {
        if (!members.length) return null;
        const firstMember = members[0];

        return (
            <section className="mt-4">
                <div className="row py-4">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 cw-bg-grey text-white">Sign Off</h6>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        {members.map((member) => (
                            <p key={member.id} className="my-0">
                                Operative: {member.name}
                            </p>
                        ))}

                        <p className="my-0">Signature:</p>

                        {firstMember.signature && (
                            <div className="col-md-2">
                                <img
                                    className="img-fluid mb-2"
                                    loading="lazy"
                                    src={`/storage/media/providers/${firstMember.service_provider_id}/team/images/${firstMember.id}/signature/${firstMember.signature}`}
                                    alt={`${firstMember.name} signature`}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </section>
        );
    };

    const renderApproval = () => {
        return (
            <section className="mt-3">
                <div className="row">
                    <div className="col-12">
                        {approved ? (
                            <span className="badge badge-success">Reviewed</span>
                        ) : (
                            <button className="btn btn-success" onClick={handleApprove}>
                                <i className="fas fa-check-circle"></i> Approve
                            </button>
                        )}
                    </div>
                </div>
            </section>
        );
    };

    if (loading) {
        return (
            <div className="text-center py-5">
                <i className="fas fa-spinner fa-spin"></i> Loading waste tipping...
            </div>
        );
    }

    if (!waste) return null;

    return (
        <>
            <WasteDetailsForm waste={waste} tipOff={tipOff} />
            <WasteTippingJobs tippingId={waste.id} initialJobs={jobs} />
            <WasteTippingReceipts wasteId={waste.id} receipts={receiptList} />
            {renderSignOff()}
            {renderApproval()}
        </>
    );
};

export default WasteTippingForm;
const el = document.getElementById('waste-tipping-root');

if (el) {
    ReactDOM.render(<WasteTippingForm wasteId={el.dataset.wasteId} />, el);
}
